import { render, staticRenderFns } from "./SearchSedeComponent.vue?vue&type=template&id=0abd34bf&"
import script from "./SearchSedeComponent.vue?vue&type=script&lang=js&"
export * from "./SearchSedeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports